export default __webpack_public_path__ + "static/media/soybeans_grains.9cbffdd1.png";